const PRESET_1_KEY = 'OnlinePrograms_ProgramsList_Preset1';
const PROGRAMSLIST_PRESETS_IMAGE =
  'onlinePrograms/addPanel/onlinePrograms_programsList_322px.png';
const PRESET_2_KEY = 'OnlinePrograms_ProgramsList_Preset2';
const PRESET_3_KEY = 'OnlinePrograms_ProgramsList_Preset3';

export { PRESET_1_KEY, PROGRAMSLIST_PRESETS_IMAGE, PRESET_2_KEY, PRESET_3_KEY };
